import dialogActions from 'core/dialogs/actions';
import pageActions from '../page/actions';
import fieldActions from '../fields/actions';
import groupActions from '../groups/actions';

export default (state = {}, action) => {
  switch (action.type) {
    case dialogActions.SEND_CODE_SUCCESS:
    case pageActions.GO_SUCCESS:
    case groupActions.UPLOAD_SUCCESS:
    case fieldActions.RERENDER_SUCCESS:
      return action.payload.data.meta.resources || state;
    case pageActions.NEXT_FAILED:
    case groupActions.NEXT_FAILED:
    case dialogActions.AGREE_SUCCESS:
      if (action.payload.data.meta) {
        return {
          ...state,
          ...action.payload.data.meta.resources,
        };
      }
      return state;
    default:
      return state;
  }
};
